// extracted by mini-css-extract-plugin
export default {"container":"XC-z","dimension":"YC-z","dimensionLabels":"ZC-z"};